// German

export default {
  component: {

    supportLink: 'support@recright.com',

    layout: {
      endTime: date => (date ? `offen bis ${date}` : ''),
    },
    interview: {
      title: 'Antwort auf das Video-Interview',
      submit: 'Antworten absenden und Interview abschließen',
      continueLater: 'Später fortfahren',
      startInterview: 'Interview beginnen',
      duplicateError: 'Du hast bereits an diesem Interview teilgenommen. Du hast eine E-Mail von invitations@recright.com erhalten, die einen Link enthält, den Du zum Fortsetzen des Interviews verwenden kannst.',
      confirmSubmitHeader: 'Du hast nicht alle Interviewfragen beantwortet',
      confirmSubmitContent: 'Möchtest Du das Interview wirklich beenden?',
      confirmSubmitContentWarning: 'Danach kannst Du Deine Antworten nicht abschließen.',
      submitInterviewHeader: 'Reichen Sie Ihre Antworten auf das Interview ein',
      submitInterviewContent: 'Sind Sie sicher, dass Sie Ihr Interview einreichen wollen?',
      confirmSubmitButton: 'Antworten absenden und Interview abschließen',
      preview: 'Hier kannst du eine Vorschau der Videofragen ansehen.',
      withdrawLink: 'Sie sind an dieser Position nicht mehr interessiert? Ziehen Sie sich hier aus dem Prozess zurück.',
    },

    personalInterview: {
      title: 'Select time for an appointment',
      description: [
        'You have been invited to an appointment.',
        'Please select a time slot that suits you best.',
      ],
      position: 'Position:',
      location: 'Location:',
      time: 'Time:',
      timezoneNotice: [
        'Please keep in mind that the times are shown in your timezone.',
        'Your timezone appears to be:',
        'The appointment timezone is:',
      ],
      success: {
        title: 'Thank you',
        description: 'You have successfully scheduled a meeting',
        linkDescription: [
          'You can add the calendar invitation to your own calendar below.',
          'Or you can copy the link to your calendar app:',
        ],
        link: 'Add the calendar invitation to your calendar',
      },
    },

    interviewForm: {
      name: 'Name',
      email: 'E-Mail',
      phone: 'Telefonnummer',
      city: 'Stadt',
      link: 'Link',
      legendBasicInfo: 'Allgemeine Informationen',
      placeholderName: 'Gib Deinen Namen ein',
      placeholderEmail: 'Gib Deine E-Mail-Adresse ein',
      placeholderPhone: 'Gib Deine Telefonnummer ein',
      placeholderCity: 'Gib Deinen aktuellen Wohnort ein',
      placeholderLink: 'Füge einen Link hinzu, z. B. zu Deinem LinkedIn-Profil.',
      legendAttachments: 'Anhänge',
      legendAdditionalFields: 'Zusätzliche Informationen',
      required: 'Mit einem * Stern gekennzeichnete Felder sind Pflichtfelder.',
    },

    sequencedInterview: {
      networkTest: {
        audio: 'Audio',
        video: 'Video',
        yes: 'Ja',
        no: 'Nein',
        supported: 'Unterstützt',
        quality: 'Qualität',
        header: 'Netzwerkverbindung und Gerätetest',
        description: 'Wir führen jetzt einen Test durch, um sicherzustellen, dass Ihre Netzwerkverbindung und die für das Interview benötigte Hardware (Kamera und Telefon) ordnungsgemäß funktionieren. Wenn Sie dazu aufgefordert werden, erlauben Sie dem Test bitte, sowohl Ihre Kamera als auch Ihr Mikrofon zu verwenden, und stellen Sie sicher, dass Ihre Kamera nicht verdeckt ist. Der Test dauert etwa 30 Sekunden. Wir empfehlen Ihnen, während des Hardwaretests zu sprechen.',
        inProgress: 'Test läuft... ',
        networkTestResults: 'Netzwerk-Testergebnisse',
        qualityTestResults: 'Qualitäts-Testergebnisse',
        testPassedQuality: 'Qualitätsprüfung bestanden',
        testFailedQuality: 'Qualitätstest nicht bestanden',
        testPassedNetwork: 'Netzwerktest bestanden',
        testFailedNetwork: 'Netzwerktest fehlgeschlagen',
        startTest: 'Test starten',
        startInterview: 'Interview starten',
        testAgain: 'Erneut testen',
        confirmWarning: 'Wenn Ihr Video-Interview beginnt, werden Sie automatisch zur ersten Interview-Frage weitergeleitet. Nachdem Sie sich die Frage angesehen haben, werden Sie zur Vorbereitung weitergeleitet.',
        confirmTitle: 'Ihr Interview beginnt gleich.',
        confirmText: 'Sie haben vor jeder Frage kurz Zeit, um Ihre Antwort vorzubereiten. Nach der Vorbereitung haben Sie eine vorgegebene Zeit, um die Frage zu beantworten. Bitte beachten Sie, dass Sie Ihre Antwort absenden können, sobald Sie dazu bereit sind, auch bevor die voreingestellte Antwortzeit abgelaufen ist.',
        confirmText2: 'Nach dem Absenden Ihrer Antwort werden Sie zur nächsten Frage weitergeleitet, bis alle Fragen beantwortet sind.',
        confirmText3:
          'Bitte beachten Sie, dass Sie nach der Aufzeichnung Ihrer Antwort auf eine Frage ein 30-Sekunden-Zeitfenster haben, um Ihre Antwort zu wiederholen, wenn dies für die Frage erlaubt ist. Wenn Sie nicht innerhalb dieser 30 Sekunden mit der Wiederholung beginnen, wird Ihre aktuelle Antwort automatisch übermittelt und Sie werden zur nächsten Frage weitergeleitet.',
        goodLuck: 'Atmen Sie einfach tief durch und alles wird gut. Viel Glück!',
        qualityRating: {
          excellent: 'Ausgezeichnet',
          good: 'Gut',
          fair: 'Mittelmäßig',
          poor: 'Niedrig',
          bad: 'Schlecht',
        },
      },
      questionAnswerView: {
        title: title => `Antwort auf das Interview ${title}`,
        question: 'Frage',
        submitAndNext: 'Senden & Weiter',
        submitSuccess: 'Video erfolgreich hochgeladen',
        skipText: 'Aufnahme starten',
        stop: 'Anhalten',
        submitAndFinish: 'Abschicken und Interview beenden',
        retake: 'Erneut aufnehmen',
        take: 'Aufnehmen',
        takesLeft: 'Übrige Aufnahmen',
        skipTextQuestion: 'Bereit? Weiter',
        retakeConfirmTitle: 'Sind Sie sicher, dass Sie Ihre Antwort auf diese Frage wiederholen möchten?',
        retakeConfirmSubmit: 'Ja, mit der Wiederholung beginnen',
        submitInfoForward: 'Ihre aktuelle Antwort wird automatisch übermittelt und Weiterleitung in',
        submitInfoForward2: 'Sekunden',
        nonAnswerableText: 'Diese Nachricht erfordert keine Antwort. Nach dieser Nachricht werden Sie direkt zur nächsten Frage weitergeleitet.',
        nonAnswerableVideo: 'Dieses Video erfordert keine Antwort. Nach diesem Video werden Sie direkt zur nächsten Frage weitergeleitet.',
        answerTimeInfo: (answerMinutes, answerSeconds) =>
          `Sie haben ${answerMinutes} Minuten und ${answerSeconds} Sekunden Zeit, um die Frage zu beantworten.`,
      },
      publisher: {
        toNextQuestion: timer => `Wechsel zur nächsten Frage in ${timer}`,
        recordingStarts: timer => `Die Aufnahme beginnt in ${timer}`,
      },
      errors: {
        tooManyConnections: 'Diese Verbindung wurde geschlossen, weil Sie bereits eine Verbindung in einem anderen Tab oder Fenster geöffnet haben.',
        unsupportedBrowser: 'Leider wird dieser Vorgang von Ihrem Browser nicht unterstützt. Bitte verwenden Sie einen anderen Browser.',
        networkError: 'Keine Internetverbindung',
        reconnecting: 'Die Verbindung wurde unterbrochen. Ich versuche, mich wieder zu verbinden.',
        generalError: 'Etwas ist schief gelaufen. Bitte aktualisieren Sie die Seite und versuchen Sie es erneut.',
        allowMediaDevicesError: 'Es konnten keine Mediengeräte (Kamera oder Mikrofon) gefunden werden. Bitte überprüfen Sie, ob Sie dem Browser die Verwendung von Kamera und Mikrofon erlaubt haben.',
        noAvailableDevicesError: 'Wir konnten keine Kamera oder Mikrofon finden',
        initPublisherError: 'Der Vorgang ist aufgrund eines Fehlers fehlgeschlagen. Bitte vergewissern Sie sich, dass Sie dem Browser erlaubt haben, Ihre Kamera und Ihr Mikrofon zu verwenden, und dass diese nicht von einer anderen Anwendung verwendet werden, und versuchen Sie es erneut.',
      },
      browserInfo: {
        browserSupportTitle: 'Browser-Unterstützung',
        supportedBrowsers: 'Dieser Test und das Interview unterstützen die neuesten Versionen von Chrome, Firefox, Safari und Edge.',
        mobileSupported: 'Unterstützte Browser auf dem Handy',
        android: 'Android: Google Chrome (neueste Version), Firefox (neueste Version)',
        iOS: 'iOS: Safari (neueste Version)',
        latestVersion: 'Bitte stellen Sie sicher, dass Sie die neueste Browser-Version verwenden, damit alles reibungslos funktioniert.',
        freezeInstruction: 'Wenn die Videoaufnahme nicht startet oder der Aufnahmebildschirm schwarz bleibt, aktualisieren Sie bitte die Seite.',
        unsupportedOnIos: 'Es sieht so aus, als ob Sie einen nicht unterstützten Browser unter iOS verwenden. Bitte benutzen Sie Safari.',
        ieUnsupported: 'Es sieht so aus, als würden Sie Internet Explorer verwenden. Leider wird der Internet Explorer für diesen Test oder dieses Interview nicht unterstützt. Bitte verwenden Sie einen anderen Browser.',
        qualityTestNotSupported: 'Leider wird das Testen der Hardware in dem von Ihnen verwendeten Browser nicht unterstützt. Sie können das Interview fortsetzen, ohne die Audio- und Videoqualität zu testen, oder alternativ einen anderen Browser verwenden.',
      },
      reconnectSuccess: 'Wieder erfolgreich verbunden!',
      continue: 'Weiter',
    },

    withdraw: {
      title: 'Sie sind an dieser Position nicht mehr interessiert? ',
      description: 'Ziehen Sie sich aus dem Einstellungsverfahren zurück.',
      buttonText: 'Rückzug aus dem Einstellungsverfahren',
      thankYouTitle: 'Vielen Dank!',
      thankYouText: 'Sie haben jetzt den Stellenanbieter darüber informiert, dass Sie nicht mehr an der Position interessiert sind.',
      confirm: 'Sind Sie sicher, dass Sie sich aus dem Einstellungsprozess zurückziehen möchten? Sie können dann nicht mehr auf dieses Interview oder ein Interview im Zusammenhang mit dieser Position antworten.',
    },
  },

  page: {
    embeddedProfileInterview: {
      submit: 'Absenden',
      continue: 'Weiter',
      supportCenter: 'Recright Help Center',
      thankYou:
        'Vielen Dank für Ihre Antwort! Wir werden mit Ihnen in naher Zukunft in Kontakt sein!',
    },
    supportLink: 'support@recright.com',

    finished: {
      title: 'Danke für Deine Teilnahme an dem Interview!',
      reopenDescription: 'Falls Sie dieses Interview aus Versehen abgebrochen haben, keine Panik! Sie können das Interview wieder öffnen, indem Sie auf den Button unten klicken!',
      reopenButtonText: 'Interview fortsetzen',
      description1: 'Super, Sie haben alle Fragen beantwortet. Ihre Antworten wurden an den Empfänger geschickt.',
      descriptionsupport: mailto => `Falls Du dieses Interview versehentlich geschlossen hast, wende Dich bitte an unseren Kundendienst ${mailto}, und wir öffnen Dein Interview erneut.`,
      descriptionfeedback: 'Deine Erfahrung ist uns wichtig! Wie war Dein Eindruck vom Beantworten eines Video-Interviews? Wie würdest Du unseren Dienst verbessern? Hinterlasse uns hier Dein Feedback.',
      feedbackbutton: 'Hinterlasse uns Feedback!',
      regularUrl: 'https://www.surveymonkey.com/r/B3ZCSWT',
      timedUrl: 'https://www.surveymonkey.com/r/MZMLPPT',
    },
    messages: {
      title: 'Persönliche Nachricht',
    },
    closed: {
      title: 'Interview ist abgeschlossen oder wurde beendet',
      description: 'Das Video-Interview, zu dem Du eingeladen wurdest, ist bereits beendet, oder Du hast Deine Antworten bereits eingereicht.',
      publicTitle: 'Interview has ended',
      publicDescription: 'The video interview has already ended.',
    },

    saved: {
      title: 'Dein Video-Interview ist jetzt gespeichert!',
      description: 'Wenn Du mit dem Video-Interview fortfahren möchtest, verwende den Link, den Du per E-Mail erhalten hast. Bereits aufgezeichnete Video-Antworten sind gespeichert, wenn Du das Interview fortsetzt! Viel Glück bei der Jobsuche!',
      remember: 'Denke daran, die Antworten an den Personalverantwortlichen zu senden, nachdem Du alle Interview-Fragen beantwortet hast.',
      deleteHistory: 'Falls Du das Video-Interview auf einem öffentlichen Computer absolvierst, denke bitte daran, Deinen Browser-Verlauf zu löschen. Dadurch ist Dein Interview sicher.',
    },
    unpublished: {
      title: 'Das Interview hat noch nicht begonnen',
      publishTime: publishTime => `Das Interview beginnt um ${publishTime}`,
    },
  },
}
